/* import __COLOCATED_TEMPLATE__ from './button.hbs'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { next } from '@ember/runloop';
import { Keys } from 'ember-headlessui/utils/keyboard';
let Button = (_class = class Button extends Component {
  onKeydown(event) {
    if (event.target.disabled) return;
    switch (event.key) {
      case Keys.Space:
      case Keys.Enter:
      case Keys.ArrowDown:
        event.preventDefault();
        event.stopPropagation();
        if (this.args.isOpen && event.key === Keys.Enter) {
          this.args.closeMenu();
        } else {
          this.args.openMenu();
          next(() => {
            this.args.goToFirstItem();
          });
        }
        break;
      case Keys.ArrowUp:
        event.preventDefault();
        event.stopPropagation();
        this.args.openMenu();
        next(() => {
          this.args.goToLastItem();
        });
        break;
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "onKeydown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onKeydown"), _class.prototype), _class);
export { Button as default };